import { ChangeDetectionStrategy, Component } from "@angular/core";

/* eslint-disable @tseslint/no-extraneous-class */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-authenticate-ui-headline",
  templateUrl: "headline.component.html",
  styleUrl: "headline.component.scss",
  standalone: true
})
export class HeadlineComponent {}
/* eslint-enable @tseslint/no-extraneous-class */

